/**
 * Given some token amount, return the max that can be spent of it
 * @param currencyAmount to return max of
 */
export function maxAmountSpend(currencyAmount?: number, symbol?: string, storageFee?: number): number | undefined {
  const fee = storageFee || 0.001
  return symbol === 'FLOW' ? (currencyAmount ?? fee) - fee : currencyAmount
}
